import { normalizeImageMime } from './prepare-avatar-core';

export type ImagePickerAsset = {
  uri: string;
  type?: string;
  fileName?: string;
  file?: File;
};

type ImagePickerResponse = {
  didCancel?: boolean;
  assets?: ImagePickerAsset[];
};

export function imagePickerAssetFromFile(file: File): ImagePickerAsset {
  return {
    uri: URL.createObjectURL(file),
    type: normalizeImageMime(file.type) || 'image/jpeg',
    fileName: file.name || 'avatar.jpg',
    file,
  };
}

function pickerInput() {
  const existing = document.getElementById('clubhouse-avatar-input') as HTMLInputElement | null;
  if (existing) {
    existing.value = '';
    return existing;
  }
  const input = document.createElement('input');
  input.id = 'clubhouse-avatar-input';
  input.type = 'file';
  input.accept = 'image/jpeg,image/jpg,image/png,image/webp,image/heic,image/heif,image/*';
  input.setAttribute('aria-hidden', 'true');
  input.tabIndex = -1;
  Object.assign(input.style, {
    position: 'fixed',
    left: '0',
    top: '0',
    width: '1px',
    height: '1px',
    opacity: '0',
    pointerEvents: 'none',
  });
  document.body.appendChild(input);
  return input;
}

export async function launchImageLibrary(_options?: Record<string, unknown>): Promise<ImagePickerResponse> {
  return new Promise(resolve => {
    const input = pickerInput();
    let settled = false;

    const finish = (result: ImagePickerResponse) => {
      if (settled) {
        return;
      }
      settled = true;
      input.onchange = null;
      input.removeEventListener('cancel', onCancel);
      window.removeEventListener('focus', onReturn);
      document.removeEventListener('visibilitychange', onReturn);
      resolve(result);
    };

    const onCancel = () => finish({ didCancel: true, assets: [] });

    const onReturn = () => {
      window.setTimeout(() => {
        if (!settled && !input.files?.length) {
          onCancel();
        }
      }, 700);
    };

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        onCancel();
        return;
      }
      finish({ didCancel: false, assets: [imagePickerAssetFromFile(file)] });
    };

    input.addEventListener('cancel', onCancel);
    window.setTimeout(() => {
      window.addEventListener('focus', onReturn);
      document.addEventListener('visibilitychange', onReturn);
    }, 400);

    input.click();
  });
}
